import fssaLogo from "../../../../assets/images/fssa_logo_cut.png";

function MainHeaderComponent() {
  return (
    <div className="main-header-container">
      <div className="container bds-container">
        <div className="bds-header-inner">
          <div className="bds-header-brand">
            <img className="fssa-logo" src={fssaLogo} alt="Indiana FSSA" />
            <div className="bds-header-titles">
              <a href="/" className="site-name">BDS Services Application</a>
              <span className="site-subtitle">Indiana Family &amp; Social Services Administration</span>
            </div>
          </div>
          <div className="bds-header-actions">
          </div>
        </div>
      </div>
    </div>
  );
}

export const MainHeader = MainHeaderComponent;
